module.exports = __webpack_public_path__ + "static/media/land-mint-1st-bg.ed28053a.png";